module.exports = __webpack_public_path__ + "img/ad2.a6317c23.png";